import { render, staticRenderFns } from "./MsgLeftText.vue?vue&type=template&id=2675df0d&scoped=true&"
import script from "./MsgLeftText.vue?vue&type=script&lang=js&"
export * from "./MsgLeftText.vue?vue&type=script&lang=js&"
import style0 from "./MsgLeftText.vue?vue&type=style&index=0&id=2675df0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675df0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2675df0d')) {
      api.createRecord('2675df0d', component.options)
    } else {
      api.reload('2675df0d', component.options)
    }
    module.hot.accept("./MsgLeftText.vue?vue&type=template&id=2675df0d&scoped=true&", function () {
      api.rerender('2675df0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/msg/MsgLeftText.vue"
export default component.exports